// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OWwVgSzF334J8j {
  min-width: 552px;
  margin: 0;
  padding: 0 8px 8px 16px;
  overflow-x: hidden;
  overflow-y: auto;
}
.ihoqhSzA6nVe_l {
  position: relative;
  margin: 12px 40px 0 56px;
}
.ihoqhSzA6nVe_l h2 {
  margin: 4px 0 0;
  padding-top: 8px;
}
.oDoug3PcrDdvUV {
  position: absolute;
  top: 8px;
  left: -40px;
}
.kEXRjh_Ltd49HN {
  padding: 0 52px;
}
@media only screen and (max-width: 750px) {
  .kEXRjh_Ltd49HN {
    padding: 0;
  }
}
.f44hG1w7zkwgm8 {
  border-bottom: 1px solid var(--ds-border, #091e4224);
  position: relative;
  margin-bottom: 8px;
  padding: 8px 0;
}
.ff_Fq5QJeECDqS {
  margin: 6px 16px 6px 0;
  float: left;
}
.Xit53AYUPxLELp {
  top: 4px;
  right: 0;
  float: right;
}
.LwFOjvTdaHXA67 {
  margin-left: 4px;
}
.fIfLR9q29Fwaxd {
  clear: both;
}
.Rtfp5YRM_okxL4 {
  display: inline-block;
  margin: 0 5px 10px 8px;
  padding: 6px 10px;
  border-radius: 3px;
  background: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  cursor: default;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  font-weight: 700;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shortcutsContainer": `OWwVgSzF334J8j`,
	"header": `ihoqhSzA6nVe_l`,
	"icon": `oDoug3PcrDdvUV`,
	"list": `kEXRjh_Ltd49HN`,
	"item": `f44hG1w7zkwgm8`,
	"itemHeader": `ff_Fq5QJeECDqS`,
	"itemKeys": `Xit53AYUPxLELp`,
	"helpIcon": `LwFOjvTdaHXA67`,
	"itemDesc": `fIfLR9q29Fwaxd`,
	"keyboardKey": `Rtfp5YRM_okxL4`
};
export default ___CSS_LOADER_EXPORT___;
